import { useMutation, useQuery, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import type { AuthUser, LoginResponse } from '@runik/shared';
import { auth } from './client';

export const meQueryKey = ['me'] as const;

export function useUser() {
  return useQuery<AuthUser | null>({
    queryKey: meQueryKey,
    queryFn: () => auth.me(),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}

export function useLogin(): UseMutationResult<LoginResponse, Error, { email: string; password: string }> {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ email, password }) => auth.login(email, password),
    onSuccess: (data) => {
      qc.setQueryData(meQueryKey, data.user);
    },
  });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => auth.logout(),
    onSuccess: () => {
      qc.clear();
    },
  });
}
